import {Tooltip} from '@mui/material'
import {Box, Loading, Typography} from '@viptech/react-components'
import {useEffect, useState} from 'react'
import RowHover from 'src/components/RowHover/RowHover'
import TableData from 'src/components/table/components/tableData/TableData'
import Table from 'src/components/table/Table'
import {SyntheticResponse} from 'src/services/api/endpoints/ReportsEndpoint'

type DashboardCountCardProps = {
  title: string
  loading: boolean
  refetching?: boolean
  rows: SyntheticResponse[] | undefined
  footerValues: FooterValuesType
  nameOnColumn: string
}

type FooterValuesType = {
  totalValue: number
  totalLastYear: number
  totalPercentage: number
  totalDelta: number
}

function CardToTables({title, loading, refetching, rows, footerValues, nameOnColumn}: DashboardCountCardProps) {
  const titleOnColumn = title === 'Visitantes' ? 'Lojas' : 'Conversão'

  const [columns, setColumns] = useState([
    {
      id: 'lojas',
      name: titleOnColumn,
    },
    {
      id: 'atual',
      name: 'Atual',
    },
    {
      id: 'last',
      name: nameOnColumn ?? 'Ano Passado',
    },
    {
      id: '%',
      name: '%',
    },
    {
      id: 'delta',
      name: 'Delta',
    },
  ])

  useEffect(() => {
    if (!nameOnColumn) return
    setColumns((prev) => {
      const columnLast = prev.find((it) => it.id === 'last')
      if (!columnLast) return []
      columnLast.name = nameOnColumn
      return prev
    })
  }, [nameOnColumn])

  const footerColumns = [
    {
      id: 'name',
      name: 'Total Geral',
    },
    {
      id: 'total value',
      name: String(footerValues.totalValue),
    },
    {
      id: 'total last year',
      name: String(footerValues.totalLastYear),
    },
    {
      id: 'total percent',
      name: `${footerValues.totalPercentage}%`,
    },
    {
      id: 'total delta',
      name: String(footerValues.totalDelta),
    },
  ]

  return (
    <Box position='relative' backgroundColor='white' borderRadius='16px' width='100%' padding='24px 32px' style={{boxShadow: '0px 5px 8px 2px #00000026'}}>
      <Box display='flex' width='100%' direction='column' justifyContent='space-between' align='center' rowGap='20px'>
        <Box display='flex' direction='column' rowGap='6px' align='center' justifyContent='center' width='100%'>
          <Typography variant='label' size='16px' color='#55565B' weight={600} children={title} />

          {(loading || refetching) && (
            <Tooltip title='Buscando atualizações' placement='top'>
              <Box position='absolute' right='24px' display='flex' columnGap='8px'>
                <Loading size='20px' />
              </Box>
            </Tooltip>
          )}
        </Box>

        <Box width='100%'>
          <Table
            isLoading={false}
            skeletonRowsAmount={20}
            isOpenAdvancedSearch={false}
            columns={columns}
            headerBorder='transparent'
            headerBackgroundColor='#EAECF0'
            headerBorderRadius='8px'
            headerPaddingLeft='20px'
            headerColor='#55565B'
            headerFontWeight='600'
            footer={footerColumns}>
            {rows?.map((row) => {
              return (
                <RowHover id={`row-${row.name}`} cursorType='auto'>
                  <TableData id={`row-nae-${row.name}`} paddingLeft='20px' color='#55565B' fontWeight='400'>
                    {row.name}
                  </TableData>
                  <TableData id={`row-value-${row.name}`} paddingLeft='20px' color='#55565B' fontWeight='400'>
                    {row.actualResult}
                  </TableData>
                  <TableData id={`row-year-${row.name}`} paddingLeft='20px' color='#55565B' fontWeight='400'>
                    {row.lastResult ?? 0}
                  </TableData>
                  <TableData id={`row-percen-${row.name}`} paddingLeft='20px' color={row.percentage && row.percentage < 0 ? '#D92D20' : '#039855'}>
                    {row.percentage ? row.percentage.toFixed(2) : 0}%
                  </TableData>
                  <TableData id={`row-delta-${row.name}`} paddingLeft='20px' color='#55565B' fontWeight='400'>
                    {row.delta ?? 0}
                  </TableData>
                </RowHover>
              )
            })}
          </Table>
        </Box>
      </Box>
    </Box>
  )
}

export default CardToTables
